import { render, staticRenderFns } from "./PremierCircle.vue?vue&type=template&id=31b2803b&scoped=true&"
import script from "./PremierCircle.vue?vue&type=script&lang=js&"
export * from "./PremierCircle.vue?vue&type=script&lang=js&"
import style0 from "./PremierCircle.vue?vue&type=style&index=0&id=31b2803b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2803b",
  null
  
)

export default component.exports